import { pickBy } from 'lodash';
export const getArticleMedias = (state, articleId) => {
    return pickBy(state.articleMedias.resources, (articleMedia) => articleMedia.article === articleId);
};
